module.exports = __webpack_public_path__ + "static/media/not_sel.574fc178.svg";